import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { adminLeaves, defaultAdminPath, legacyRedirects } from '@/config/adminNavigation'
import { initMenu } from '@/utils/MenuUtils'

Vue.use(Router)

const viewLoaders = {
    Channels: () => import('@/views/Channels.vue'),
    Operators: () => import('@/views/Operators.vue'),
    ServicePackages: () => import('@/views/ServicePackages.vue'),
    DriverAudits: () => import('@/views/DriverAudits.vue'),
    Orders: () => import('@/views/Orders.vue'),
    Roles: () => import('@/views/Roles.vue'),
    Permissions: () => import('@/views/Permissions.vue'),
    Accounts: () => import('@/views/Accounts.vue'),
    Cities: () => import('@/views/Cities.vue'),
}

const adminRoutes = adminLeaves.map(item => ({
    path: item.path.replace(/^\//, ''),
    name: item.routeName,
    component: viewLoaders[item.view],
    meta: {
        requiresAuth: true,
        title: item.title,
        description: item.description,
        icon: item.icon,
        sectionTitle: item.sectionTitle,
        titlePath: item.titlePath,
    },
}))

const getMenuChildren = (node = {}) => node.controls || node.children || []

const normalizePath = (path = '') => {
    const value = String(path || '').trim()
    if (!value) return ''
    return value.startsWith('/') ? value : `/${value}`
}

export const getPermissionHomePath = (menus = store.state.permissionMenus || []) => {
    const walk = (items = []) => {
        for (let index = 0; index < items.length; index += 1) {
            const item = items[index]
            const childPath = walk(getMenuChildren(item))
            if (childPath) {
                return childPath
            }

            const ownPath = normalizePath(item.path)
            if (ownPath) {
                return ownPath
            }
        }
        return ''
    }

    return walk(menus) || defaultAdminPath
}

const constantRoutes = [
        {
            path: '/login',
            name: 'Login',
            component: () => import('@/views/Login1.vue'),
            meta: { requiresAuth: false },
        },
        {
            path: '/login1',
            name: 'Login1',
            component: () => import('@/views/Login1.vue'),
            meta: { requiresAuth: false },
        },
        {
            path: '/404',
            name: 'NotFound',
            component: () => import('@/views/NotFound.vue'),
            meta: { requiresAuth: false },
        },
        {
            path: '/',
            component: () => import('@/layout/Layout.vue'),
            meta: { requiresAuth: true },
            children: [
                {
                    path: '',
                    redirect: () => getPermissionHomePath(),
                },
                ...adminRoutes,
                {
                    path: 'management/cities',
                    name: 'Cities',
                    component: viewLoaders.Cities,
                    meta: {
                        requiresAuth: true,
                        title: '城市管理',
                        description: '管理城市开通状态。',
                        icon: 'environment',
                        sectionTitle: '基础管理',
                        sectionKey: 'city-management',
                        titlePath: ['基础管理', '城市管理'],
                    },
                },
            ],
        },
        ...Object.keys(legacyRedirects).map(path => ({
            path,
            redirect: legacyRedirects[path],
        })),
        {
            path: '*',
            redirect: to => ({
                path: '/404',
                query: to && to.fullPath ? { from: to.fullPath } : {},
            }),
        },
]

const createRouter = () => new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: constantRoutes,
})

const router = createRouter()

let dynamicRoutesSignature = ''

export const ensurePermissionRoutes = (menus = store.state.permissionMenus || []) => {
    if (!Array.isArray(menus) || !menus.length) {
        return []
    }

    const signature = JSON.stringify(menus)
    if (signature === dynamicRoutesSignature) {
        return []
    }

    const routes = initMenu(menus)
    if (routes.length) {
        router.addRoutes(routes)
        dynamicRoutesSignature = signature
    }

    return routes
}

export const resetRouter = () => {
    router.matcher = createRouter().matcher
    dynamicRoutesSignature = ''
}

if (store.getters['user/isLoggedIn'] && store.state.permissionMenus.length) {
    ensurePermissionRoutes(store.state.permissionMenus)
}

export default router
